import { client } from "../../../api/axiosConfig";

export const submitAnswers = (data) => {
  return client.post("/submit-answers", data);
};

export const submitAdditionalImpacts = (data) => {
  return client.post("/submit-additional-impacts", data);
};

export const submitReferral = (data) => {
  return client.post("/submit-referral", data);
};

export const getScore = (athleteId) => {
  return client.get(`/get-score/${athleteId}`);
};
